module.exports = __webpack_public_path__ + "static/media/woocommerce_text_logo.7e3ae106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect_store/woocommerce_text_logo.png
// module id = 1535
// module chunks = 0